module.exports = __webpack_public_path__ + "img/esypellets-logo.6a4a33d.svg";